module.exports = __webpack_public_path__ + "img/chrome.1a5aa680.svg";